
import Messages3 from "../../../assets/filled/Messages3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Messages3Icon({ className, dataTestid = "Messages3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Messages3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
